<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->
<well-google-address-list [list]="predictions"
                          [error]="status ? ('address.google.status.' + status | translate) : null"
                          (selectPrediction)="onSelect($event)"></well-google-address-list>



